import { render, staticRenderFns } from "./Trilha.vue?vue&type=template&id=1598aec6"
import script from "./Trilha.vue?vue&type=script&lang=js"
export * from "./Trilha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports